import { contentListQueries } from '../../queries';
import { queryClient } from 'src/config/request';
export async function handleImportContent(extra) {
    const { queryKey, queryFn } = contentListQueries.getModules({ extra: Boolean(extra) });
    const modules = await queryClient.fetchQuery({ queryKey, queryFn, staleTime: 0 });
    if (modules.length > 0) {
        return modules[modules.length - 1]?.id || '';
    }
    return '';
}
